import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import './Button.scss'

const Button = ({
  children,
  onClick,
  className,
  disabled,
  active,
  ...attrs
}) => {
  useInterfaceLanguage();
  const onClickAction = (e) => {
    if (disabled) {
      e.preventDefault()
    } else {
      return onClick(e)
    }
  }

  const classes = classNames('btn', className, { active })

  const Tag = attrs.href ? 'a' : 'button'

  return (
    <Tag
      className={classes}
      disabled={disabled}
      onClick={onClickAction}
      {...attrs}
    >
      {children}
    </Tag>
  )
}

Button.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
}

Button.defaultProps = {
  children: 'Default button',
  onClick: () => {},
  className: '',
  disabled: false,
  active: false,
}

export default Button
